module.exports = __webpack_public_path__ + "static/media/sass.74c36290.png";